// extracted by mini-css-extract-plugin
export default {"card":"blockOneSettings_card__z0YMc","content":"blockOneSettings_content__J7qwb","select":"blockOneSettings_select__IekPH"};